// pages/components/shared/listingHandlers.js
//
// The reference doc's #5 finding: MyExportCSV (139 copies), routeChange
// (286), status_change (38), and the date-range handlers (87 combined) are
// identical or near-identical everywhere they appear. This extracts each
// into one implementation. Lowest-risk item on the whole list — none of
// these change behaviour, they just stop being copy-pasted.

import React from "react";
import { T } from "react-translator-component"; // matches payroll_line_entry/Listing.js's own import

// Was duplicated 139 times verbatim (payroll_line_entry/Listing.js line 389
// is one example) — every copy was byte-for-byte the same component.
export const MyExportCSV = ({ onExport }) => (
  <button
    className="btn btn-secondary mt-2"
    style={{ margin: "0rem 1.5rem 0rem 0rem" }}
    onClick={onExport}
  >
    {T("Export")}
  </button>
);

// Confirmed identical in payroll_line_entry/Listing.js, attendance/Listing.js,
// and projects/Listing.js (`this.props.history.push("/")`). Call this instead
// of defining routeChange() as an instance method in every class.
export const routeChange = (history) => {
  history.push("/");
};

// status_change bodies differ slightly per screen (some track `this.sid`,
// others `this.dep_id`), but the SHAPE is identical: take a react-select
// value (possibly null), pull it into local state, and derive an id for the
// next query. Parameterising the state key and id field covers every
// variant seen without forcing a screen to change its own state shape.
export const makeStatusChangeHandler = (component, { stateKey = "status", idRef = "sid" } = {}) => {
  return (selectedStatus) => {
    component.setState({ [stateKey]: selectedStatus });
    if (selectedStatus === null || selectedStatus === undefined) {
      component[idRef] = 0;
    } else {
      const values = Object.values(selectedStatus);
      component[idRef] = values[0];
    }
  };
};

// Covers handleFromDateChange / handleToDateChange (46 + 41 occurrences).
// Both were simple setState-and-store-on-instance patterns; this keeps that
// exact shape so it's a drop-in for either direction.
export const makeDateChangeHandler = (component, { stateKey, instanceKey }) => {
  return (date) => {
    component.setState({ [stateKey]: date });
    if (instanceKey) {
      component[instanceKey] = date;
    }
  };
};
